export { createI18n, defaultNamespace } from './createI18n';
export { I18NContext, mockT, useT, withT } from './hooks/useT';
export { LocaleProvider, useLocale } from './hooks/useLocale';
//# sourceMappingURL=index.js.map